import Stats, { getStatsPathName } from "./pages/protected/stats/Stats.jsx";
import {
  Navigate,
  Outlet,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import Protected from "./pages/protected/Protected.jsx";
import Login from "./pages/unprotected/login/Login.jsx";
import ErrorPage from "./pages/unprotected/errors/ErrorPage.jsx";
import Campaigns from "./pages/protected/stats/campaigns/Campaigns.jsx";
import LeadsTracking from "./pages/protected/leadsTracking/LeadsTracking.jsx";
import EmailAddedPage from "./pages/unprotected/success/EmailAddedPage.jsx";
import EmailNotAdded from "./pages/unprotected/errors/EmailNotAdded.jsx";
import CampaignContacts from "./pages/protected/stats/campaigns/contacts/CampaignContacts.jsx";
import Error404 from "./pages/unprotected/errors/Error404.jsx";
import { findList } from "./api/ContactAPI.js";
import { findFolder } from "./api/FolderAPI.js";
import { useUIStore } from "./stores/UIStore.js";
import ModelPageEdit from "./pages/protected/models/ModelPageEdit.jsx";
import ModelPageCreate from "./pages/protected/models/ModelPageCreate.jsx";
import ModelListing from "./pages/protected/models/ModelListing.jsx";
import { getModelTypeProps } from "./pages/protected/models/modelUtils.jsx";
import { findAIKey, findApiKey } from "./api/ConfigsApi.js";
import CreateMassMailing from "./pages/protected/senders/emails/massmailing/CreateMassMailing.jsx";
import UnsubsImportPage from "./pages/protected/exclusions/unsubs/UnsubsImportPage.jsx";
import BlacklistImportPage from "./pages/protected/exclusions/blacklists/BlacklistImportPage.jsx";
import ApiListing from "./pages/protected/api/ApiListing.jsx";
import CreateApiKeyPage from "./pages/protected/api/CreateApiKeyPage.jsx";
import ApiKeyUse from "./pages/protected/api/ApiKeyUse.jsx";
import NetworkError from "./pages/unprotected/errors/NetworkError.jsx";
import { findOrg, findReseller, findTeam } from "./api/UserAPI.js";
import TagsListing from "./pages/protected/tools/tags/TagsListing.jsx";
import CreateUrlPage from "./pages/protected/tools/urlShortener/CreateUrlPage.jsx";
import Signup from "./pages/unprotected/signup/Signup.jsx";
import FilesListing from "./pages/protected/files/FilesListing.jsx";
import FilePage from "./pages/protected/files/FilePage.jsx";
import { findFile } from "./api/FIleAPI.js";
import CreateUserPage from "./pages/protected/resellers/createUser/CreateUserPage.jsx";
import { useLanguage } from "./stores/LanguageStore.js";
import FallbackPage from "./pages/unprotected/errors/FallbackPage.jsx";
import WorkflowListingPage from "./pages/protected/workflows/listing/WorkflowListingPage.jsx";
import AccountVerifiedPage from "./pages/unprotected/success/AccountVerifiedPage.jsx";
import ImportSmtp from "./pages/protected/senders/emails/import/ImportSmtp.jsx";
import PasswordRecovery from "./pages/unprotected/password-recovery/PasswordRecovery.jsx";
import JoinPage from "./pages/protected/community/JoinPage.jsx";
import Support from "./pages/support/Support.jsx";
import { getKnowledges } from "./pages/support/knowledges.jsx";
import GroupPage from "./pages/support/base/GroupPage.jsx";
import BaseList from "./pages/support/base/BaseList.jsx";
import ContentPage from "./pages/support/base/ContentPage.jsx";
import SubscriptionCancelled from "./pages/unprotected/errors/SubscriptionCancelled.jsx";
import { Suspense } from "react";
import SuspenseFallback from "./pages/unprotected/SuspenseFallback.jsx";
import CreateCampaignComponent from "./pages/protected/workflows/CreateCampaign/CreateCampaign.jsx";
import DirectLinkReply from "./pages/unprotected/replies/DirectLinkReply.jsx";
import Test from "./pages/Test.jsx";
import AIKeyListing from "./pages/protected/tools/integrations/AIKeyListing.jsx";
import EditAiKeyPage from "./pages/protected/tools/integrations/EditAiKeyPage.jsx";
import CreateAiKeyPage from "./pages/protected/tools/integrations/CreateAiKeyPage.jsx";
import Home from "./pages/protected/home/Home.jsx";
import ContactListImport from "./pages/protected/lists/import/ContactListImport.jsx";
import ModelLinkedinListing from "./pages/protected/models/ModelLinkedinListing.jsx";
import ListingWithContent from "./pages/protected/lists/ListingWithContent/ListingWithContent.jsx";
import LoginOAuth from "./pages/unprotected/login/LoginOAuth.jsx";
import ModelsPageWrapper from "./pages/protected/models/wrapper/ModelsPageWrapper.jsx";
import ModelFolders from "./pages/protected/models/wrapper/ModelFolders.jsx";
import SendersPageWrapper from "./pages/protected/senders/wrapper/SendersPageWrapper.jsx";
import SendersPools from "./pages/protected/senders/wrapper/SendersPools.jsx";
import CreateSmtpPage from "./pages/protected/senders/emails/smtp/CreateSmtpPage.jsx";
import LinkedinSendersListing from "./pages/protected/senders/linkedin/LinkedinSendersListing.jsx";
import LinkedinPageCreate from "./pages/protected/senders/linkedin/LinkedinPageCreate.jsx";
import EmailSendersListing from "./pages/protected/senders/emails/EmailSendersListing.jsx";
import Settings from "./pages/protected/settings/Settings.jsx";
import SettingsProfile from "./pages/protected/settings/SettingsProfile.jsx";
import ResellersListing from "./pages/protected/settings/resellers/ResellersListing.jsx";
import ResellerPage from "./pages/protected/settings/resellers/ResellerPage.jsx";
import CreateReseller from "./pages/protected/settings/resellers/CreateReseller.jsx";
import CampaignsListing from "./pages/protected/stats/campaigns/CampaignsListing.jsx";
import WorkflowListing from "./pages/protected/stats/campaigns/workflows/WorkflowListing.jsx";
import FoldersListing from "./pages/protected/lists/ListingWithContent/contacts/FoldersListing.jsx";
import Reporting from "./pages/protected/reporting/Reporting.jsx";
import FormsListing from "./pages/protected/models/forms/FormsListing.jsx";
import FormCreate from "./pages/protected/models/forms/FormCreate.jsx";
import FormEdit from "./pages/protected/models/forms/FormEdit.jsx";
import AdminPanel from "./pages/protected/admin/AdminPanel.jsx";
import TeamSettings from "./pages/protected/settings/teams/TeamSettings.jsx";
import TeamPage from "./pages/protected/settings/teams/TeamPage.jsx";
import TeamListing from "./pages/protected/settings/teams/TeamListing.jsx";
import OrgSettings from "./pages/protected/settings/organizations/OrgSettings.jsx";
import OrgListing from "./pages/protected/settings/organizations/OrgListing.jsx";
import OrgPage from "./pages/protected/settings/organizations/OrgPage.jsx";
import Toolbox from "./pages/protected/settings/toolbox/Toolbox.jsx";
import FileFolders from "./pages/protected/files/FileFolders.jsx";
import LinksListing from "./pages/protected/tools/urlShortener/LinksListing.jsx";
import DatafieldsListing from "./pages/protected/tools/datafields/DatafieldsListing.jsx";
import Integrations from "./pages/protected/settings/integrations/Integrations.jsx";
import AffiliationPage from "./pages/protected/settings/affiliation/AffiliationPage.jsx";
import Subscription from "./pages/protected/settings/subscription/Subscription.jsx";
import { findBlacklist } from "./api/BlacklistAPI.js";
import CreateDatafieldPage from "./pages/protected/tools/datafields_backup/CreateDatafieldPage.jsx";
import ResellersUsers from "./pages/protected/resellers/users/ResellersUsers.jsx";
import SignupSmsConfirmation from "./pages/unprotected/signup/SignupSmsConfirmation.jsx";
import { useSupportLanguage } from "./pages/support/stores/SupportLanguageStore.js";
import DeleteBounces from "./pages/protected/settings/toolbox/bounces/DeleteBounces.jsx";
import CreateTagPage from "./pages/protected/tools/tags/CreateTagPage.jsx";
import EnrichUsage from "./pages/protected/settings/toolbox/enrichUsage/EnrichUsage.jsx";
import CookieHandler from "./CookieHandler.jsx";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import AgentsPageWrapper from "./pages/protected/ai-agent/AgentsPageWrapper.jsx";
import AgentPageCreate from "./pages/protected/ai-agent/AgentPageCreate.jsx";
import AgentListing from "./pages/protected/ai-agent/AgentListing.jsx";
import AgentPageEdit from "./pages/protected/ai-agent/AgentPageEdit.jsx";
import HomeDemo from "./pages/unprotected/HomeDemo/pages/HomeDemo.jsx";
import Newsletter from "./pages/protected/newsletter/Newsletter.jsx";
import EditAgent from "./pages/protected/ai-agent/agent/EditAgent.jsx";
import AiAssistant from "./components/Assistant/AiAssistant.jsx";

function loader(loaderFunction, responseField, param) {
  return async ({ params }) => {
    if (params[param] === "none") {
      return false;
    }
    const setLoading = useUIStore.getState().setMainLoading;
    setLoading(true);
    const response = await loaderFunction(params).catch((err) => {
      setLoading(false);
      console.log(err);
      if (err?.response) {
        throw new Response("", { status: err.response.status });
      }
      throw new Response("", { status: 418 });
    });

    setLoading(false);
    if (response) return response?.data?.[responseField];
  };
}

function getPathName(nameField = "name", idField = "id") {
  return (data) => {
    if (data) return `${data?.[nameField] || ""} #${data[idField]}`;
    return "?";
  };
}

function stopLoaderOnChild() {
  return ({ currentUrl, nextUrl }) => {
    return nextUrl.pathname.length <= currentUrl.pathname.length;
  };
}

function getRouteParentProps({
  findFunction = () => {},
  disableDefaultFind,
  param,
  responseField,
  id,
  withHandle = true,
  isFolder,
}) {
  return {
    shouldRevalidate: stopLoaderOnChild(),
    loader: loader(
      (params) =>
        findFunction(disableDefaultFind ? params : parseInt(params[param])),
      responseField,
      param,
    ),
    id: id,
    handle: withHandle
      ? {
          getName: getPathName(),
          isFolder,
        }
      : undefined,

    errorElement: <ErrorPage />,
  };
}

const getSupportRoutes = () => {
  const lang = useSupportLanguage.getState().language;

  return (
    <Route>
      <Route index element={<BaseList />} />
      {getKnowledges(lang).map((group) => (
        <Route
          key={group.url}
          path={group.url}
          handle={{
            group: group,
          }}
        >
          <Route index element={<GroupPage groupUrl={group.url} />} />
          {group.items.map((item) => (
            <Route
              key={item.url}
              path={item.url}
              element={<ContentPage groupUrl={group.url} url={item.url} />}
              handle={{
                itemUrl: item.url,
              }}
            />
          ))}
        </Route>
      ))}
    </Route>
  );
};

const getRoutes = (lang) => {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route element={<RootLayout />}>
        <Route path="/maintenance" element={<ErrorPage status={503} />} />
        <Route path="/home-demo" element={<HomeDemo />} />
        <Route
          path="/login"
          element={<Login />}
          handle={{
            name: lang.login.title,
          }}
        />
        <Route path="/oauth/:provider/login" element={<LoginOAuth />} />
        <Route
          path="/signup"
          element={<Signup />}
          handle={{
            name: lang.signup.title,
          }}
        />
        <Route
          path="/signup-verification"
          element={<SignupSmsConfirmation />}
          handle={{
            name: lang.signup.sms_confirmation.title,
          }}
        />
        <Route
          path="/password-recovery"
          element={<PasswordRecovery />}
          handle={{
            name: lang.password_recovery.step_verify.title,
          }}
        />
        <Route path="/reply" element={<DirectLinkReply />} />

        <Route path="/test" element={<Test />} />

        {/* Support */}
        <Route path="/support" element={<Support />}>
          {getSupportRoutes()}
        </Route>

        {/* Successes */}
        <Route path="/success">
          <Route path="email" element={<EmailAddedPage />} />
          <Route path="account" element={<AccountVerifiedPage />} />
        </Route>

        {/* Errors */}
        <Route path="/error">
          <Route path="email" element={<EmailNotAdded />} />
          <Route path="subscription" element={<SubscriptionCancelled />} />
        </Route>

        <Route
          path="/leads-tracking/contact/:contactId"
          element={<LeadsTracking isSheet />}
        />
        <Route path="/" element={<Protected />} errorElement={<ErrorPage />}>
          <Route
            index
            element={<Home />}
            handle={{
              name: lang.home.browser_tab_title,
            }}
          />

          {/* Campaign Creator */}
          <Route
            path="campaign"
            handle={{
              name: lang.campaigns.campaign,
            }}
          >
            <Route path="create" element={<CreateCampaignComponent />} />
            <Route
              path="create/horizontal"
              element={<CreateCampaignComponent isHorizontal />}
            />
            <Route
              path="create/workflow/:workflowId"
              element={<CreateCampaignComponent />}
            />
            <Route
              path="edit/:campaignId/workflow/:workflowId"
              element={<CreateCampaignComponent />}
            />
          </Route>

          <Route
            path="newsletter"
            handle={{
              name: lang.campaigns.campaign,
            }}
          >
            <Route path="create/:modelId" element={<Newsletter />} />
            <Route
              path="edit/:campaignId/workflow/:workflowId"
              element={<Newsletter />}
            />
          </Route>

          {/* List */}
          <Route
            path="contact-lists"
            handle={{
              name: lang.contact_lists.browser_tab_title,
            }}
          >
            <Route index element={<Navigate replace to={"none"} />} />

            <Route
              path="import"
              handle={{
                name: lang.routes.import,
              }}
              element={<ContactListImport />}
            >
              <Route path="*" element={<Navigate to=".." replace />} />
            </Route>

            <Route path=":contactListId">
              <Route index element={<ListingWithContent />} />
              <Route
                path="import"
                {...getRouteParentProps({
                  id: "contact-list",
                  param: "contactListId",
                  responseField: "contact_list_profile",
                  findFunction: findList,
                })}
                element={<ContactListImport />}
              >
                <Route path="*" element={<Navigate to=".." replace />} />
              </Route>
            </Route>

            <Route path="folder">
              <Route
                index
                element={<Navigate replace to={"none/list/none"} />}
              />

              <Route path=":folderId/list/:contactListId">
                <Route index element={<ListingWithContent />} />
                <Route
                  path="import"
                  handle={{
                    name: lang.routes.import,
                  }}
                  element={<ContactListImport />}
                >
                  {/* <Route
                    path=":method"
                    element={<ImportListPage />}
                    loader={({ params }) => params}
                    handle={{
                      getName: (params) =>
                        getListMethod().find((x) => x.value === params?.method)
                          ?.title || "?",
                    }}
                  /> */}
                </Route>
              </Route>
            </Route>
          </Route>

          {/* Blacklists */}
          <Route
            path="blacklists"
            handle={{
              name: lang.routes.exclusion.blacklist,
            }}
          >
            <Route index element={<Navigate replace to={"none"} />} />

            <Route
              path="import"
              element={<BlacklistImportPage />}
              handle={{ name: lang.routes.import }}
            />

            <Route path=":blacklistId">
              <Route
                index
                element={<ListingWithContent type="/blacklists" />}
              />
              <Route
                path="import"
                {...getRouteParentProps({
                  id: "blacklist",
                  param: "blacklistId",
                  responseField: "blacklist_profile",
                  findFunction: findBlacklist,
                })}
                element={<BlacklistImportPage />}
                handle={{ name: lang.routes.import }}
              />
            </Route>
          </Route>

          {/* Unsubs */}
          <Route
            path="unsubscribers"
            handle={{
              name: lang.routes.exclusion.unsubs,
            }}
          >
            <Route index element={<Navigate replace to={"none"} />} />
            <Route
              path="import"
              element={<UnsubsImportPage />}
              handle={{ name: lang.routes.import }}
            />
            <Route path=":orgId">
              <Route
                index
                element={<ListingWithContent type="/unsubscribers" />}
              />
              <Route
                path="import"
                {...getRouteParentProps({
                  id: "unsub_org",
                  param: "orgId",
                  responseField: "organization_profile",
                  findFunction: findOrg,
                })}
                element={<UnsubsImportPage />}
                handle={{ name: lang.routes.import }}
              />
            </Route>
          </Route>

          {/* Model */}
          <Route
            path="models"
            handle={{ name: lang.routes.models.models }}
            element={<ModelsPageWrapper />}
          >
            <Route index element={<Navigate replace to={"/models/email"} />} />
            <Route
              path="linkedin"
              handle={{ name: lang.routes.models.linkedin }}
              element={<ModelLinkedinListing />}
            />

            <Route
              path=":modelType"
              loader={({ params }) => params}
              handle={{
                getName: (params) =>
                  getModelTypeProps(params.modelType)?.pathName || "Model",
              }}
            >
              <Route index element={<Navigate replace to={"none"} />} />
              <Route
                path="create"
                element={<ModelPageCreate />}
                handle={{ name: lang.routes.creation }}
              />
              <Route
                path="create-ai"
                element={<ModelPageCreate is_ai />}
                handle={{ name: lang.routes.models.ai_email }}
              />
              <Route path=":modelId">
                <Route index element={<ModelListing />} />
                <Route
                  path="edit"
                  element={<ModelPageEdit loaderId="model" />}
                  handle={{ name: lang.routes.edit }}
                />
              </Route>
            </Route>

            <Route path="folder">
              <Route index element={<Navigate to={"none/model/none/type"} />} />

              <Route path="none/model/none/type" element={<ModelFolders />} />

              <Route
                path=":folderId/model/:modelId/:modelType"
                element={<ModelListing />}
              />

              <Route
                path=":folderId/create/:modelType"
                element={<ModelPageCreate />}
                handle={{ name: lang.routes.creation }}
              />
            </Route>
          </Route>

          {/* Forms */}
          <Route path="forms" handle={{ name: lang.navbar.forms }}>
            <Route index element={<Navigate replace to={"list"} />} />
            <Route path="list" element={<FormsListing />} />

            <Route
              path="create"
              element={<FormCreate />}
              handle={{ name: lang.routes.creation }}
            />

            <Route path=":formId" element={<FormEdit />} />
          </Route>

          {/* Senders */}
          <Route
            path="senders"
            handle={{
              name: lang.routes.senders.senders,
            }}
            element={<SendersPageWrapper />}
          >
            <Route index element={<Navigate replace to={"email/none"} />} />
            {/* Email Accounts */}
            <Route
              path="email"
              handle={{
                name: lang.routes.models.emails,
              }}
            >
              <Route index element={<Navigate replace to={"none"} />} />
              <Route
                path="create/massmailing"
                element={<CreateMassMailing />}
                handle={{
                  name: lang.routes.senders.create_massmailing,
                }}
              />
              <Route
                path="create/smtp"
                element={<CreateSmtpPage />}
                handle={{
                  name: lang.routes.senders.create_smtp,
                }}
              />
              <Route
                path="import/smtp"
                element={<ImportSmtp />}
                handle={{
                  name: lang.routes.senders.import_smtp,
                }}
              />
              <Route path=":accountId" element={<EmailSendersListing />} />
            </Route>

            {/* Pool Email */}
            <Route
              path="pool"
              handle={{
                name: lang.routes.senders.pools,
              }}
            >
              <Route index element={<Navigate to={"none/email/none"} />} />
              <Route path="none/email/none" element={<SendersPools />} />

              <Route
                path=":poolId/email/:accountId"
                element={<EmailSendersListing />}
              />

              <Route
                path=":poolId/email/create/smtp"
                element={<CreateSmtpPage />}
                handle={{
                  name: lang.routes.senders.create_smtp,
                }}
              />
            </Route>

            {/* LinkedIn Accounts */}
            <Route
              path="linkedin"
              handle={{
                name: lang.routes.senders.linkedins,
              }}
            >
              <Route index element={<Navigate replace to={"none"} />} />
              <Route
                path="create"
                element={<LinkedinPageCreate />}
                handle={{
                  name: lang.routes.senders.add_account,
                }}
              />
              <Route path=":accountId" element={<LinkedinSendersListing />} />
            </Route>

            {/* Pool LinkedIn */}
            <Route
              path="pool"
              handle={{
                name: lang.routes.senders.pools,
              }}
            >
              <Route index element={<Navigate to={"none/linkedin/none"} />} />
              <Route
                path="none/linkedin/none"
                element={<SendersPools type="Linkedin" />}
              />

              <Route
                path=":poolId/linkedin/:accountId"
                element={<LinkedinSendersListing />}
              />

              <Route
                path=":poolId/linkedin/create"
                element={<CreateSmtpPage />}
                handle={{
                  name: lang.routes.senders.add_account,
                }}
              />
            </Route>
          </Route>

          {/* Stats */}
          <Route
            path="statistics"
            handle={{
              name: lang.routes.stats.stats,
            }}
            element={<Stats />}
          >
            <Route index element={<Navigate to={"campaigns"} replace />} />

            <Route
              path="campaigns"
              handle={{
                name: lang.routes.stats.campaigns,
              }}
              element={<Campaigns />}
            >
              <Route index element={<Navigate to={"running"} replace />} />
              <Route path=":filter" element={<CampaignsListing />} />
              <Route path="workflows">
                <Route index element={<WorkflowListing />} />

                <Route path="folder">
                  <Route
                    index
                    element={<Navigate to={"none/workflow/none"} />}
                  />

                  <Route
                    path="none/workflow/none"
                    element={
                      <FoldersListing
                        type="Workflow"
                        mainUrl="/statistics/campaigns/workflows"
                        keyword="workflow"
                      />
                    }
                  />

                  <Route
                    path=":folderId/workflow/:wokflowId"
                    element={<WorkflowListing />}
                  />
                </Route>
              </Route>
            </Route>

            <Route
              path="campaigns/:campaign/workflow/:workflow/contacts/:type"
              element={<CampaignContacts />}
              loader={({ params }) => params}
              handle={{
                getName: getStatsPathName,
              }}
            />
            <Route
              path="campaigns/:campaign/workflow/:workflow/step/:stepId/contacts/:type/:stepType"
              element={<CampaignContacts />}
              loader={({ params }) => params}
              handle={{
                getName: getStatsPathName,
              }}
            />
          </Route>

          {/* Reporting */}
          <Route
            path="reporting"
            element={<Reporting />}
            handle={{ name: lang.routes.senders.reports }}
          />

          <Route path="workflows" handle={{ name: lang.routes.campaigns }}>
            <Route index element={<WorkflowListingPage />} />

            <Route
              element={<WorkflowListingPage />}
              path="folder/:folderId"
              {...getRouteParentProps({
                id: "workflow-folder",
                param: "folderId",
                responseField: "folder_profile",
                findFunction: findFolder,
                isFolder: true,
              })}
            />
          </Route>

          {/* Leads */}
          <Route path="leads-tracking" handle={{ name: lang.routes.prm }}>
            <Route index element={<LeadsTracking />} />
            <Route path=":userId" element={<LeadsTracking />} />
          </Route>

          {/* Account Settings */}
          <Route
            path="settings"
            handle={{ name: lang.routes["account-settings"] }}
            element={<Settings />}
          >
            <Route index element={<Navigate to={"profile"} />} />
            <Route path="profile" element={<SettingsProfile />} />

            <Route
              path="organizations"
              handle={{
                name: lang.routes.organizations,
              }}
            >
              <Route index element={<Navigate replace to={"none"} />} />
              <Route path="create" element={<OrgSettings />} />
              <Route path="none" element={<OrgListing />} />
              <Route
                path=":orgId"
                {...getRouteParentProps({
                  param: "orgId",
                  id: "organization",
                  responseField: "organization_profile",
                  findFunction: findOrg,
                })}
              >
                <Route index element={<Navigate replace to={"users"} />} />
                <Route
                  path="add-user"
                  element={<CreateUserPage type="organization" />}
                />
                <Route path=":tab" element={<OrgPage />} />
              </Route>
            </Route>

            <Route
              path="teams"
              handle={{
                name: lang.routes.resellers,
              }}
            >
              <Route index element={<Navigate replace to={"none"} />} />
              <Route path="create" element={<TeamSettings />} />
              <Route path="none" element={<TeamListing />} />
              <Route
                path=":teamId"
                {...getRouteParentProps({
                  param: "teamId",
                  id: "team",
                  responseField: "team_profile",
                  findFunction: findTeam,
                })}
              >
                <Route index element={<Navigate replace to={"users"} />} />
                <Route
                  path="add-user"
                  element={<CreateUserPage type="team" />}
                />
                <Route path=":tab" element={<TeamPage />} />
              </Route>
            </Route>

            <Route path="permissions" handle={{ name: lang.routes.admin }}>
              <Route index element={<Navigate replace to={"none"} />} />
              <Route path=":userId" element={<AdminPanel />} />
            </Route>

            <Route path="tools" handle={{ name: "Toolbox" }}>
              <Route index element={<Toolbox />} />

              {/* Files */}
              <Route
                path="files"
                handle={{
                  name: lang.routes.files,
                }}
              >
                <Route index element={<FilesListing />} />
                <Route
                  path="create"
                  element={<FilePage />}
                  handle={{
                    name: lang.routes.add,
                  }}
                />
                <Route
                  path=":fileId/edit"
                  element={<FilePage />}
                  {...getRouteParentProps({
                    param: "fileId",
                    responseField: "file_profile",
                    findFunction: findFile,
                  })}
                />

                <Route path="folder">
                  <Route
                    index
                    element={<Navigate to={"none/file/none"} replace />}
                  />
                  <Route path="none/file/none" element={<FileFolders />} />

                  <Route
                    path=":folderId"
                    {...getRouteParentProps({
                      id: "file-folder",
                      param: "folderId",
                      responseField: "folder_profile",
                      findFunction: findFolder,
                      isFolder: true,
                    })}
                  >
                    <Route
                      index
                      element={<Navigate to={"file/none"} replace />}
                    />
                    <Route path="file/:fileId" element={<FilesListing />} />
                    <Route
                      path="file/:fileId/edit"
                      element={<FilePage />}
                      {...getRouteParentProps({
                        param: "fileId",
                        responseField: "file_profile",
                        findFunction: findFile,
                      })}
                    />
                    <Route
                      path="file/create"
                      element={<FilePage />}
                      handle={{
                        name: lang.routes.add,
                      }}
                    />
                  </Route>
                </Route>
              </Route>

              {/* Datafields */}
              <Route
                path="datafields"
                handle={{
                  name: "Datafields",
                }}
              >
                <Route index element={<DatafieldsListing />} />

                <Route path="create" element={<CreateDatafieldPage />} />
              </Route>

              {/* Tags */}
              <Route
                path="tags"
                handle={{
                  name: "Tags",
                }}
                element={<TagsListing />}
              />
              <Route
                path="tags"
                handle={{
                  name: "Tags",
                }}
              >
                <Route index element={<TagsListing />} />

                <Route
                  path="create"
                  element={<CreateTagPage />}
                  handle={{ name: lang.routes.creation }}
                />
              </Route>

              {/* URL Shortener */}
              <Route
                path="links"
                handle={{
                  name: lang.routes.url_shortener,
                }}
              >
                <Route index element={<Navigate to={"none"} />} />
                <Route path=":linkId" element={<LinksListing />} />

                <Route
                  path="create"
                  element={<CreateUrlPage />}
                  handle={{ name: lang.routes.creation }}
                />
              </Route>

              {/* Bounces */}
              <Route
                path="bounces"
                handle={{
                  name: "Bounces",
                }}
              >
                <Route index element={<DeleteBounces />} />
              </Route>

              {/* EnrichUsage */}
              <Route
                path="enrich-usage"
                handle={{
                  name: "Enrich Usage",
                }}
              >
                <Route index element={<EnrichUsage />} />
              </Route>
            </Route>

            <Route path="integrations">
              <Route index element={<Navigate replace to={"api"} />} />
              <Route path=":tab" element={<Integrations />}>
                <Route path=":apiId" element={<Integrations />} />
              </Route>
            </Route>

            <Route path="my-network" element={<AffiliationPage />} />

            <Route path="subscription">
              <Route index element={<Navigate replace to={"account"} />} />
              <Route path=":tab" element={<Subscription />} />
            </Route>

            <Route path="*" element={"[En cours]"} />
          </Route>

          {/* API */}
          <Route path="api" handle={{ name: lang.routes.api }}>
            <Route index element={<ApiListing />} />
            <Route
              path="create"
              element={<CreateApiKeyPage />}
              handle={{ name: lang.routes.creation }}
            />
            <Route
              path=":apiKeyId"
              element={<ApiKeyUse />}
              {...getRouteParentProps({
                param: "apiKeyId",
                responseField: "apikey_profile",
                findFunction: findApiKey,
              })}
            />
          </Route>

          {/* Resellers */}
          <Route
            path="resellers"
            handle={{
              name: lang.routes.resellers,
            }}
          >
            <Route index element={<Navigate replace to={"none"} />} />
            <Route path="create" element={<CreateReseller />} />
            <Route path="none" element={<ResellersListing />} />
            <Route
              path=":resellerId"
              {...getRouteParentProps({
                param: "resellerId",
                id: "reseller",
                responseField: "reseller_profile",
                findFunction: findReseller,
              })}
            >
              <Route index element={<Navigate replace to={"users"} />} />
              <Route path="add-user" element={<CreateUserPage />} />
              <Route path=":tab" element={<ResellerPage />} />
            </Route>
          </Route>

          {/* Community */}
          <Route
            path="community"
            handle={{
              name: lang.routes.community,
            }}
          >
            <Route index element={<Navigate to={"teams"} replace />} />

            <Route
              path="join"
              element={<JoinPage />}
              handle={{
                name: lang.routes.join,
              }}
            />

            {/* <Route
              path="teams"
              handle={{
                name: lang.routes.teams,
              }}
            >
              <Route index element={<TeamListing />} />

              <Route
                path="create"
                element={<CreateTeamPage />}
                handle={{ name: lang.routes.creation }}
              />
              <Route
                path=":teamId"
                {...getRouteParentProps({
                  param: "teamId",
                  id: "team",
                  responseField: "team_profile",
                  findFunction: findTeam,
                })}
              >
                <Route index element={<Navigate to={"users"} replace />} />

                <Route path="users" handle={{ name: lang.routes.users }}>
                  <Route index element={<UsersList />} />
                  <Route
                    path=":userId"
                    {...getRouteParentProps({
                      param: "userId",
                      responseField: "user_profile",
                      findFunction: getProfile,
                    })}
                    element={<AdminPage />}
                  />
                </Route>
              </Route>
            </Route> */}
          </Route>

          {/* Integrations */}
          <Route
            path="integrations"
            handle={{
              name: lang.integrations.browser_tab_title,
            }}
          >
            <Route index element={<AIKeyListing />} />

            <Route
              path="create"
              element={<CreateAiKeyPage />}
              handle={{ name: lang.routes.creation }}
            />

            <Route
              path=":apiKey"
              element={<EditAiKeyPage />}
              {...getRouteParentProps({
                param: "apiKey",
                responseField: "external_api_key_profile",
                findFunction: findAIKey,
              })}
            />
          </Route>

          {/* Agents */}
          <Route
            path="agents"
            handle={{ name: "Agents" }}
            element={<AgentsPageWrapper />}
          >
            <Route index element={<AgentListing />} />
            <Route
              path="create"
              element={<AgentPageCreate />}
              handle={{ name: lang.routes.creation }}
            />
            <Route
              path="edit/:agentId"
              element={<EditAgent />}
              handle={{ name: lang.routes.edit }}
            />
          </Route>

          {/* Magileads */}
          <Route
            path="magileads"
            handle={{
              name: "Magileads",
            }}
          >
            <Route index element={<ResellersUsers />} />
          </Route>

          {/* Ai Assistant */}
          <Route
            path="assistant"
            handle={{
              name: "Assistant IA",
            }}
            element={<AiAssistant />}
          />

          {/* 404 Error */}
          <Route
            path="*"
            element={<Error404 />}
            errorElement={<NetworkError />}
          />
        </Route>
      </Route>,
    ),
  );
};

export const Routes = () => {
  const lang = useLanguage((s) => s.language);

  return (
    <Suspense fallback={<SuspenseFallback />}>
      <RouterProvider
        fallbackElement={<FallbackPage />}
        router={getRoutes(lang)}
        key={lang.id}
      />
    </Suspense>
  );
};

export const RootLayout = () => {
  return (
    <ModalsProvider modalProps={{ keepMounted: false }}>
      <Notifications
        zIndex={10000}
        w={"auto"}
        styles={{
          notification: {
            boxShadow: "#00000021 0 2px 4px",
            marginRight: 54,
            border: "1px solid #00000021",
          },
        }}
      />
      <CookieHandler />

      {/* <Outlet /> est vital : c'est ici que React Router insérera 
          le composant de la route actuelle (Accueil, Profil, etc.) */}
      <Outlet />
    </ModalsProvider>
  );
};
